<template>
    <div :class="className">
        <div class="popup-backdrop" />
        <div
            class="popup"
            @click="handleClick">
            <div class="popup-dialog">
                <div
                    ref="content"
                    class="popup-content">
                    <span
                        v-if="closeButton"
                        class="modal-close ic-exit"
                        @click.stop="hide"/>
                    <slot :hide="hide"/>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.popup-dialog {
    min-height: calc(100% - 160px);
    margin: 80px 160px;
    display: flex;
    align-items: center;
    justify-content: center;
}
@media (max-width: 992px) {
    .popup-dialog {
        margin: 0 auto;
    }
    .popup-content{
        width: 90% !important;
    }
}

.popup-content {
    background: white;
    padding: 20px;
    border-radius: 20px;
    position:relative;
}

.popup-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1040;
    background-color: #000;
    opacity: 0.1;
}

.popup {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99999;
    outline: 0;
    overflow-x: hidden;
    overflow-y: auto;
}
.modal-close {
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
    z-index:2;
}

</style>
<script>
// TODO: Overflow on body, padding on body
// Scroll width: window.innerWidth - document.documentElement.clientWidth
export default {
    props: {
        className: {
            type: String,
            default: ''
        },
        closeButton: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        hide () {
            this.$emit('hide');
        },
        handleClick (e) {
            if (!this.$refs.content.contains(e.target)) {
                this.hide();
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/js/frontend/components/Modal.vue